import { render, staticRenderFns } from "./DocumentSeriesForm.vue?vue&type=template&id=70483d5e&"
import script from "./DocumentSeriesForm.vue?vue&type=script&lang=js&"
export * from "./DocumentSeriesForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports